import request from "@/utils/request";

const create = (formData) => request
  .post("/api/ratings", {
    body: formData,
    token: true
  });

export default {
  create
};
